<script setup lang="ts">
import type { ComboboxInputProps } from '@blintz/radix-vue';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { ComboboxInput, useForwardProps } from '@blintz/radix-vue';
import { computed } from 'vue';

defineOptions({
	inheritAttrs: false
});

const props = defineProps<
	ComboboxInputProps & {
		class?: HTMLAttributes['class'];
		wrapperClasses?: HTMLAttributes['class'];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
const emit = defineEmits<{
	(e: 'update:modelValue', value: string): void;
}>();

const updateValue = (e: Event) => {
	const target = e.target as HTMLInputElement;
	emit('update:modelValue', target.value);
};
</script>

<template>
	<div
		:class="cn('flex items-center', props.wrapperClasses)"
		cmdk-input-wrapper
	>
		<slot name="prefix" />
		<ClientOnly>
			<ComboboxInput
				v-bind="{ ...forwardedProps, ...$attrs }"
				:class="
					cn(
						'flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50',
						props.class
					)
				"
				@input="updateValue"
			/>
			<template #fallback>
				<input
					type="text"
					:placeholder="String($attrs.placeholder || '')"
					:class="
						cn(
							'flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50',
							props.class
						)
					"
				/>
			</template>
		</ClientOnly>
		<slot name="suffix" />
	</div>
</template>
